module.exports = __webpack_public_path__ + "img/ikg_logo.7d66b7b6.png";